/* eslint-disable jsx-a11y/no-onchange */
import PropTypes from "prop-types"
import { HelperShelfTrigger, HelperShelfMessage } from "components/helper_shelf"

const Select = ({
  name,
  options,
  value,
  id,
  onChange,
  className = "select",
  style = {},
  label = null,
  helperMessage = null,
  disabled = false,
  ariaLabel = "select an item"
}) => {
  return (
    <>
      {label && (
        <>
          <label className="label" htmlFor={id}>
            {label}
            {helperMessage && (
              <>
                <HelperShelfTrigger id={`helperShelf-${id}`} className="icon ml-4p" />
                <HelperShelfMessage id={`helperShelf-${id}`}>{helperMessage}</HelperShelfMessage>
              </>
            )}
          </label>
        </>
      )}
      <select
        disabled={disabled}
        className={className}
        style={style}
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        aria-label={ariaLabel}
      >
        {options.map(option => (
          <option
            key={option.key || option.value}
            value={option.value}
            selected={option.selected}
            hidden={option.hidden}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
    </>
  )
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.shape({}),
  label: PropTypes.string,
  helperMessage: PropTypes.string,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string
}

export default Select
